import React from "react";
import moment from "moment";

class Tools {
    static convertToDashCase = (value) => value && value.replace(/([A-Z]+)/g, " $1").replace(/([A-Z][a-z])/g, " $1").trim().replace(/\s+/g, '-').toLowerCase();
    static numberingSuffix = (number) => number + ['', 'st', 'nd', 'rd', 'th'][Math.min(4, number)];
    static maybePluralize = (count, noun, suffix = 's') => `${count} ${noun}${count !== 1 ? suffix : ''}`;
    static changeTitleToId = (title) => title?.toLowerCase().replace(' ', '-');

    static deepExtend = (source, copy) => {
        for (let [key, prop] of Object.entries(copy)) {
            if (typeof prop !== "object") {
                source[key] = prop;
            } else {
                Tools.deepExtend(source[key], prop)
            }
        }
        return [source, copy];
    };

    static generateToken = (length) => {
        const chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789_';
        let token = '';
        for (let i = 0; i < length; i++)
            token += chars[Math.floor(Math.random() * chars.length)];

        return token;
    };

    static toBase64 = (file) => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });


    /**
     *
     * @param text {string} The text to search within.
     * @param pattern {string} The string that will be searched for within the text.
     * @return {boolean} The result of searching.
     */
    static find = (text, pattern) => {
        return pattern === undefined || pattern == null || pattern === '' || text.toLowerCase().indexOf(pattern.toLowerCase()) !== -1;
    };

    /**
     *
     * @param array {Array} The array to search within.
     * @param pattern {string} The string that will be searched for within the array.
     * @return {boolean} The result of searching.
     */
    static findInArray = (array, pattern) => {
        return array.filter(item => Tools.find(item, pattern)).length > 0;
    };


    static redirectToErrorPage = (props, exceptMatches, code = 404) => {
        if (exceptMatches.includes(props.match.params.page)) {
            return true
        } else {
            props.history.replace(`/${code}`)
        }
    };


    static eventValue = e => e.target.value;

    static calculateAge = (d1, d2) => {
        d2 = d2 || new Date();
        const diff = d2.getTime() - d1.getTime();
        return Math.floor(diff / (1000 * 60 * 60 * 24 * 365.25));
    };


    static convertUnixToDate = (unix) => new Date(unix * 1000);
    static convertDateToYearMonth = (date) => {
        const monthNames = ["January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"
        ];

        const year = date.getUTCFullYear();
        return `${monthNames[date.getMonth()]} ${year}`;
    };

    static  formatterNumber = (num, digits = 1) => {
        const si = [
            {value: 1, symbol: ""},
            {value: 1E3, symbol: "k"},
            {value: 1E6, symbol: "M"},
            {value: 1E9, symbol: "G"},
            {value: 1E12, symbol: "T"},
            {value: 1E15, symbol: "P"},
            {value: 1E18, symbol: "E"}
        ];
        const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
        let i;
        for (i = si.length - 1; i > 0; i--) {
            if (num >= si[i].value) {
                break;
            }
        }
        return (num / si[i].value).toFixed(digits).replace(rx, "$1") + si[i].symbol;
    };

    static capitalize = (string) => {
        return string.charAt(0).toUpperCase() + string.slice(1);
    };

    static yesNo = (value) => value ? 'yes' : 'no';

    static convertEmptyToNull = value => {
        if (value === undefined || value === null)
            return null;

        if (typeof value === 'string' && value.length === 0)
            return null;

        if (Array.isArray(value) && value.length === 0)
            return null;

        return value;
    };


    static delay = (callback, ms, id) => {
        const timerName = `${id}Timer`;
        clearTimeout(this[timerName]);
        this[timerName] = setTimeout(() => {
            callback();
        }, ms);
    };

    static formatDate = (date, formatter) => {
        return moment().calendar((new Date(date)), formatter || {
            sameDay: '[Today] HH:mm',
            nextDay: '[Tomorrow] HH:mm',
            nextWeek: 'dddd HH:mm',
            sameElse: 'dddd DD/MM/YYYY HH:mm'
        });
    };

}

export default Tools;
